var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHintInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3814 7.56456L22.1136 0.714037L32.6124 7.56137L43.1632 14.4427V34.9506L32.6364 41.1296L22.1139 47.3062L11.3574 41.1268L0.599989 34.9468V14.4465L11.3814 7.56456Z",
    stroke: "#767676",
    strokeWidth: 1.19998
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.076 21.4801H22.124L25.5902 11.9995L15 26.5189H21.952L18.4858 35.9995L29.076 21.4801Z",
    fill: "#767676"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintInactive);
export default __webpack_public_path__ + "static/media/hint-inactive.11cc8d4461c4135f2f57b5cba5e1c831.svg";
export { ForwardRef as ReactComponent };